import styled from 'styled-components';
const BuilderStyle = styled.div `
	.react-select__value-container {
		input {
			width: unset !important;
			background-color: unset !important;
			color: unset !important;
			font-size: unset !important;
			line-height: unset !important;
			font-family: unset !important;
			font-weight: unset !important;
			border-radius: unset !important;
			border: unset !important;
			padding: unset !important;
		}
	}
`;
export default BuilderStyle;
//# sourceMappingURL=style.js.map